import angular from 'angular';

import StorageServiceProvider from './storage.provider';

export default angular
    .module('common.service.storage', [])
    .provider('storageService', StorageServiceProvider);



// WEBPACK FOOTER //
// ./src/common/service/storage/index.js